// removed by extract-text-webpack-plugin
module.exports = {"buttonsGroup":"eJFXin73Y44lZ0qEnrb8-","button":"_39GCba0HemiAEewuoMezAs"};


//////////////////
// WEBPACK FOOTER
// ./src/EpicMigration/components/ButtonsGroup.scss
// module id = 2914
// module chunks = 0